// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 356) return "356.97d87ec91e38caec5b3f.css";
	// return url for filenames based on template
	return "" + (chunkId === 970 ? "renderer" : chunkId) + "." + {"820":"b272fb474a7efce5e855","881":"9ff6c024f54103d0b1d7","970":"aeb0f3ea74b2d9af9a0f"}[chunkId] + ".css";
};